import { render } from "./Proofs.vue?vue&type=template&id=e8ea445e&scoped=true"
import script from "./Proofs.vue?vue&type=script&lang=js"
export * from "./Proofs.vue?vue&type=script&lang=js"

import "./Proofs.vue?vue&type=style&index=0&id=e8ea445e&scoped=true&lang=css"
import "./Proofs.vue?vue&type=style&index=1&id=e8ea445e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ea445e"]])

export default __exports__